import { DateFormat, TimeFormat } from "@nova/format"
import { GenericUpload } from "@nova/constants"
import { config } from "@nova/configuration/browser"
import { useMemo } from "react"
import { getImageDateRange } from "./module"

export const useImagesDates = (uploads: GenericUpload[] | undefined) => {
    const { organizationSettingDateFormat } = config.use("organizationSettingDateFormat")
    const { organizationSettingTimeFormat } = config.use("organizationSettingTimeFormat")
    const [startDate, endDate] = useMemo(
        () =>
            getImageDateRange(
                uploads,
                organizationSettingDateFormat as DateFormat,
                organizationSettingTimeFormat as TimeFormat
            ),
        [uploads, organizationSettingDateFormat, organizationSettingTimeFormat]
    )

    return { startDate, endDate }
}
